import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { AuthorityDecision } from 'manager/user-authority-constant';
import {
  MEMBERS_DETAIL,
  SUBCOMMITTEE_JOIN,
  CHECK_SUBCOMMITTEE_PARTICIPATION,
} from 'manager/http-constants';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import {
  CONSTANT,
  IMAGE_EXTENSION,
  LOADING_KEY,
  NUMBER,
} from 'src/app/shared/constant/constant';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';

@Component({
  selector: 'app-e401',
  templateUrl: './e401.component.html',
  styleUrls: ['./e401.component.scss', '../platform.component.scss'],
})

/**
 *  分科会参加登録
 */
export class E401Component extends PlatformComponent {
  
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを課題・ソリューション登録(C101)に変更する
    this.router.navigate(['pages/platform/e401'], {
      queryParams: {
        subcommittee_id: this.subcommitteeId,
      },
    });
  }

  // 分科会ID
  subcommitteeId: string = this.route.snapshot.queryParams.subcommittee_id;

  // 分科会参加登録情報
  memberInformation: object[] = new Array();

  // 同意チェックボックス
  agreeCheck: string;
  // 同意チェックボックス
  agreeCheckFlag: boolean = false;
  
  // 参加済みフラグ
  isAlreadyJoin: any;

  ngOnInit(): void {
    // 会員情報を取得
    this.getMemberInformation();
    // 参加登録確認
    this.isAlreadyJoinCheck();
  }

  /**
   * 会員情報を取得
   */
  public getMemberInformation(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MEMBERS_DETAIL);

    // 会員詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(MEMBERS_DETAIL, this.loginUser.member_id, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MEMBERS_DETAIL);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
        } else {
          // 会員詳細を格納
          this.memberInformation = response.body;
        }
      });
  }

  /**
   * 参加状況を取得
   */
  public isAlreadyJoinCheck(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(CHECK_SUBCOMMITTEE_PARTICIPATION);

    // 分科会参加状態チェックを取得
    this.dbOperationService
      .getNoTemplateData(CHECK_SUBCOMMITTEE_PARTICIPATION, {"subcommittee_id": this.subcommitteeId, "user_id": this.loginUser.user_id}, false)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, CHECK_SUBCOMMITTEE_PARTICIPATION);

          if (this.commonService.checkNoneResponse(response)) {
            this.isAlreadyJoin = {isalreadyjoin: 'False'};
          } else {
            // 分科会参加状態チェックを格納
            this.isAlreadyJoin = response.body;
          }
      });
  }

  /**
   * 分科会参加登録
   */
  public joinSubcommittee(): void {
    
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 参加登録確認
    if('True' == this.isAlreadyJoin?.isalreadyjoin){
      // 異常終了メッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00030),
        })
      ); 
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);
      // 強制終了
      return;
    }

    // 分科会参加登録を実施
    this.dbOperationService
      .insertData(SUBCOMMITTEE_JOIN, {subcommittee_id: this.subcommitteeId, user_id: this.loginUser.user_id})
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          // 分科会参加登録完了(E403)へ遷移
          this.router.navigate(['pages/platform/e403']);
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        }
      });
  }

  /**
   * 他画面へ遷移する
   */
  public moveToView(screenId: string): void {
    if(screenId == "e202"){
      // 分科会詳細へ遷移する
      this.router.navigate(['pages/platform/e202/' + this.subcommitteeId]);
    } else if(screenId == "b220"){
      // ユーザー管理へ遷移する
      this.router.navigate(['pages/platform/b220']);
    } else {
      // 会員プロフィール管理へ遷移する
      
      // 自治体 or 事務局ユーザが否か
      if (
        this.commonService.decisionUserAuthority(
          false,
          new AuthorityDecision({
            user_1: true,
            user_4: true,
          })
        )
      ) {
        // 自治体 or 事務局ユーザの場合

        // 会員プロフィール(自治体)(B211)へ遷移
        this.router.navigate(['pages/platform/b211/' + this.loginUser.member_id]);
      } else {
        // 民間団体の場合

        // 会員プロフィール(民間団体)(B212)へ遷移
        this.router.navigate(['pages/platform/b212/' + this.loginUser.member_id]);
      }
    }
  }

  /**
   * 同意フラグの切り替え
   */
  public setAgreeCheck(): void {
    this.agreeCheckFlag = this.agreeCheck == "checked" ?  true : false;
  }
}
